import { Injectable } from '@angular/core';
import { LoginRequest, AuthenticatedSession } from '../../models/api/auth';
import { ApiHttpProvider } from '../api-http/api-http';
import { LoginResponse, mapLoginResponse } from './auth-mapper';

@Injectable()
export class AuthProvider {
  constructor(private api: ApiHttpProvider) {}

  login(request: LoginRequest): Promise<AuthenticatedSession> {
    return this.api.postForm<LoginResponse>('usuarios/login', {
      user: request.user,
      password: request.password
    }).then(mapLoginResponse);
  }
}



// WEBPACK FOOTER //
// ./src/providers/auth/auth.ts